module.exports = __webpack_public_path__ + "static/media/rgb.4199d25a.png";